import React, { useRef, useState } from 'react';
import { getClient } from '@graphql/graphql-client/graphClient';
import { useQueryClient } from 'react-query';
import { useUpdateConversationMutation } from '@graphql/generated-graphql';
import { useUniversalModalDispatch } from '@components/context/UniversalModalContext';
import { useOnClickOutside } from '@hooks/useOnClickOutside';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { Input, Button } from '@skipper/ui';

export const EditChatNameModal = ({ conversation }: { conversation: any }) => {
    const { toggle, dispatchNotification } = useUniversalModalDispatch();
    const queryClient = useQueryClient();
    const [title, setTitle] = useState(conversation?.title);
    const elementRef = useRef<HTMLDivElement | null>(null);
    useOnClickOutside(elementRef, () => {
        toggle(false);
    });

    const updateChat = useUpdateConversationMutation(getClient('communication'), {
        onSettled: async (data) => {
            if (data?.updateConversation) {
                toggle(false);
                queryClient.invalidateQueries('conversationsList');
                queryClient.invalidateQueries(['conversationMessages', { id: conversation.id }]);
                dispatchNotification({
                    title: 'Chat name updated successfully',
                    text: '',
                    type: 'success',
                });
            } else {
                dispatchNotification({
                    title: 'Update Chat Name Error',
                    text: 'Something went wrong',
                    type: 'danger',
                });
            }
        },
    });

    return (
        <div className="fixed inset-0 overflow-y-auto flex h-full">
            <div className="relative flex-grow flex-1 flex justify-center items-center py-2">
                <div
                    className="relative bg-white rounded-md py-5 w-[370px] md:w-[550px] font-medium text-sm"
                    ref={elementRef}>
                    <div className="px-5">
                        <div className="flex justify-between items-center">
                            <h6 className="font-bold">Chat Name</h6>
                            <FontAwesomeIcon
                                icon={faXmark}
                                size="lg"
                                className="cursor-pointer"
                                onClick={() => toggle(false)}
                            />
                        </div>
                        <p className="mt-5 text-sm leading-5 font-medium text-gray-700">
                            When you change the name of a group chat, everyone in the conversation
                            will see the new name.
                        </p>
                        <p className="mt-5 mb-1 text-sm leading-5 font-medium text-gray-700">
                            Chat name
                        </p>
                        <Input
                            type="text"
                            id="chatName"
                            height="medium"
                            placeholder="Enter name here"
                            onChange={(e) => {
                                setTitle(e.target.value);
                            }}
                        />
                    </div>
                    <div className="px-5 mt-5 border-t">
                        <Button
                            variant="magenta"
                            size="medium"
                            className="mt-4 w-full"
                            onClick={() =>
                                updateChat.mutate({
                                    id: conversation?.id,
                                    title
                                })
                            }>
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
